import {Component, OnInit} from '@angular/core';
import {ModalNavigationComponent} from '../../modal/modal-navigation-component';
import {ModalNavigationService} from '../../modal/modal-navigation.service';
import {ImageUploadTransfer} from '../model';

@Component({
  selector: 'image-upload-modal',
  templateUrl: './image-upload-modal.component.html',
  styleUrls: ['./image-upload-modal.component.scss'],
  standalone: false,
})
export class ImageUploadModalComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  transfer: ImageUploadTransfer;

  constructor(private modalNavigation: ModalNavigationService) {}

  ngOnInit(): void {
    if (this.isInModalContext) {
      if (this.modalNavigation.getCurrentNavigation().data && this.modalNavigation.getCurrentNavigation().data.transfer) {
        this.transfer = this.modalNavigation.getCurrentNavigation().data.transfer;
      }
    }
  }
}
